import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#E11D48',
        secondary: '#7C3AED',
        accent: '#0F172A',
        info: '#2563EB',
        success: '#16A34A',
        warning: '#D97706',
        error: '#DC2626',
        background: '#F8FAFC',
        surface: '#FFFFFF',
      },
    },
  },
});
